import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
Vue.use(VueRouter);

// 创建并暴露一个路由器
const rout = new VueRouter({
  // mode:'history', // 去掉哈希值，把路由变为history模式
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      meta: {
        title: "登录 - 飞碟管理后台",
      },
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        title: "飞碟管理后台",
      },
      children: [
        {
          path: "/demo",
          name: "demo",
          component: () => import("./views/Demo"),
        },
        {
          path: "/demo_scroll",
          name: "demo_scroll",
          component: () => import("./views/demo_scroll"),
        },
        {
          path: "/summary",
          name: "summary_",
          component: () => import("./views/PutData/summary"),
          meta: {
            title: "投放数据看板 - 飞碟管理后台",
          },
        },
        {
          path: "/summaryB",
          name: "summaryB_",
          component: () => import("./views/PutData/summaryB"),
          meta: {
            title: "新投放数据看板 - 飞碟管理后台",
          },
        },
        {
          path: "/assistant",
          name: "assistant_",
          component: () => import("./views/PutData/assistant"),
          meta: {
            title: "投放助理数据 - 飞碟管理后台",
          },
        },
        {
          path: "/effect",
          name: "effect_",
          component: () => import("./views/PutData/effect"),
          meta: {
            title: "投放效果跟踪 - 飞碟管理后台",
          },
        },
        {
          path: "/effectB",
          name: "effectB_",
          component: () => import("./views/PutData/effectB"),
          meta: {
            title: "新投放效果跟踪 - 飞碟管理后台",
          },
        },
        {
          path: "/fansRank",
          name: "fansRank",
          component: () => import("./views/PutData/fansRank"),
          meta: {
            title: "公众号新增粉丝排行榜 - 飞碟管理后台",
          },
        },
        {
          path: "/panelWeek",
          name: "panelWeek",
          component: () => import("./views/PutData/panelWeek"),
          meta: {
            title: "投放数据周维度看板 - 飞碟管理后台",
          },
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("./views/Dashboard"),
          meta: {
            title: "投放排行 - 飞碟管理后台",
          },
        },
        {
          path: "/pitcher",
          name: "pitcher",
          component: () => import("./views/PutData/pitcher"),
          meta: {
            title: "投放数据统计投手维度 - 飞碟管理后台",
          },
        },
        {
          path: "/book",
          name: "book_",
          component: () => import("./views/PutData/book"),
          meta: {
            title: "投放数据统计书籍维度 - 飞碟管理后台",
          },
        },
        // 后台管理
        {
          path: "/users",
          name: "users_",
          component: () => import("./views/Auth/users"),
          meta: {
            title: "用户列表 - 飞碟管理后台",
          },
        },
        {
          path: "/routes",
          name: "routes_",
          component: () => import("./views/Auth/routes"),
          meta: {
            title: "路由列表 - 飞碟管理后台",
          },
        },
        {
          path: "/roles",
          name: "roles_",
          component: () => import("./views/Auth/roles"),
          meta: {
            title: "角色列表 - 飞碟管理后台",
          },
        },
        {
          path: "/menu",
          name: "menu_",
          component: () => import("./views/Auth/menu"),
          meta: {
            title: "菜单列表 - 飞碟管理后台",
          },
        },
        {
          path: "/loginLog",
          name: "loginLog_",
          component: () => import("./views/Auth/loginLog"),
          meta: {
            title: "登录日志 - 飞碟管理后台",
          },
        },
        {
          path: "/vuePath",
          name: "vuePath_",
          component: () => import("./views/Auth/vuePath"),
          meta: {
            title: "VUE路径管理页面 - 飞碟管理后台",
          },
        },
        {
          path: "/landPage",
          name: "landPage_",
          component: () => import("./views/PutMarket/landPage"),
          meta: {
            title: "落地页管理 - 飞碟管理后台",
          },
        },
        {
          path: "/landPageAdd",
          name: "landPageAdd_",
          component: () => import("./views/PutMarket/landPageAdd"),
          meta: {
            title: "落地页新增 - 飞碟管理后台",
          },
        },
        {
          path: "/landAdd360",
          name: "landAdd360_",
          component: () => import("./views/PutMarket/landAdd360"),
          meta: {
            title: "360落地页新增 - 飞碟管理后台",
          },
        },
        {
          path: "/landQuickApp",
          name: "landQuickApp_",
          component: () => import("./views/PutMarket/landQuickApp"),
          meta: {
            title: "快应用落地页管理 - 飞碟管理后台",
          },
        },
        {
          path: "/landQuickAppAdd",
          name: "landQuickAppAdd_",
          component: () => import("./views/PutMarket/landQuickAppAdd"),
          meta: {
            title: "快应用落地页新增/编辑 - 飞碟管理后台",
          },
        },
        {
          path: "/mediaList",
          name: "mediaList_",
          component: () => import("./views/PutMarket/mediaList"),
          meta: {
            title: "媒体列表管理 - 飞碟管理后台",
          },
        },
        {
          path: "/mediaPosition",
          name: "mediaPosition_",
          component: () => import("./views/PutMarket/mediaPosition"),
          meta: {
            title: "媒体版位管理 - 飞碟管理后台",
          },
        },
        {
          path: "/channelList",
          name: "channelList_",
          component: () => import("./views/PutMarket/channelList"),
          meta: {
            title: "渠道列表 - 飞碟管理后台",
          },
        },
        {
          path: "/putGzh",
          name: "putGzh_",
          component: () => import("./views/PutMarket/putGzh"),
          meta: {
            title: "投放公众号 - 飞碟管理后台",
          },
        },
        {
          path: "/putAccount",
          name: "putAccount_",
          component: () => import("./views/PutMarket/putAccount"),
          meta: {
            title: "推广账户管理 - 飞碟管理后台",
          },
          redirect: "/accountVIVO",
          children: [
            {
              path: "/accountTT",
              name: "accountTT_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountTT.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountOPPO",
              name: "accountOPPO_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountOPPO.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountVIVO",
              name: "accountVIVO_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountVIVO.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountTX",
              name: "accountTX_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountTX.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountBD",
              name: "accountBD_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountBD.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountHW",
              name: "accountHW_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountHW.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountKS",
              name: "accountKS_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountKS.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
            {
              path: "/accountWB",
              name: "accountWB_",
              component: () =>
                import("./views/PutMarket/putAccounts/accountWB.vue"),
              meta: {
                title: "推广账户管理 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/orderIndex",
          name: "orderIndex_",
          component: () => import("./views/Popularize/orderIndex.vue"),
          meta: {
            title: "订单中心 - 飞碟管理后台",
          },
          redirect: "/orderGzh",
          children: [
            {
              path: "/orderGzh",
              name: "orderGzh_",
              component: () => import("./views/Popularize/orders/orderGzh.vue"),
              meta: {
                title: "公众号订单 - 飞碟管理后台",
              },
            },
            {
              path: "/orderDZ",
              name: "orderDZ_",
              component: () => import("./views/Popularize/orders/orderDZ.vue"),
              meta: {
                title: "点众订单 - 飞碟管理后台",
              },
            },
            {
              path: "/orderCD",
              name: "orderCD_",
              component: () => import("./views/Popularize/orders/orderCD.vue"),
              meta: {
                title: "常读订单 - 飞碟管理后台",
              },
            },
            {
              path: "/orderWD",
              name: "orderWD_",
              component: () => import("./views/Popularize/orders/orderWD.vue"),
              meta: {
                title: "文鼎订单 - 飞碟管理后台",
              },
            },
            {
              path: "/orderLD",
              name: "orderLD_",
              component: () => import("./views/Popularize/orders/orderLD.vue"),
              meta: {
                title: "乐读订单 - 飞碟管理后台",
              },
            },
            {
              path: "/orderVideoXcx",
              name: "orderVideoXcx_",
              component: () =>
                import("./views/Popularize/videoXcx/orderVideoXcx.vue"),
              meta: {
                title: "短剧小程序订单 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/registerIndex",
          name: "registerIndex_",
          component: () => import("./views/Popularize/registerIndex.vue"),
          meta: {
            title: "注册用户 - 飞碟管理后台",
          },
          redirect: "/registerGzh",
          children: [
            {
              path: "/registerGzh",
              name: "registerGzh_",
              component: () =>
                import("./views/Popularize/registers/registerGzh.vue"),
              meta: {
                title: "公众号注册用户 - 飞碟管理后台",
              },
            },
            {
              path: "/registerCd",
              name: "registerCd_",
              component: () =>
                import("./views/Popularize/registers/registerCd.vue"),
              meta: {
                title: "常读快应用注册用户 - 飞碟管理后台",
              },
            },
            {
              path: "/registerWd",
              name: "registerWd_",
              component: () =>
                import("./views/Popularize/registers/registerWd.vue"),
              meta: {
                title: "文鼎快应用注册用户 - 飞碟管理后台",
              },
            },
            {
              path: "/registerLd",
              name: "registerLd_",
              component: () =>
                import("./views/Popularize/registers/registerLd.vue"),
              meta: {
                title: "乐读快应用注册用户 - 飞碟管理后台",
              },
            },
            {
              path: "/registerVideoXcx",
              name: "registerVideoXcx_",
              component: () =>
                import("./views/Popularize/videoXcx/registerVideoXcx.vue"),
              meta: {
                title: "短剧小程序注册用户 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/landPageUser",
          name: "landPageUser_",
          component: () => import("./views/Popularize/landPageUser.vue"),
          meta: {
            title: "落地页用户 - 飞碟管理后台",
          },
          redirect: "/LPzj",
          children: [
            {
              path: "/LPzj",
              name: "LPzj_",
              component: () =>
                import("./views/Popularize/landPageUsers/LPzj.vue"),
              meta: {
                title: "自建落地页用户 - 飞碟管理后台",
              },
            },
            {
              path: "/LPjmy",
              name: "LPjmy_",
              component: () =>
                import("./views/Popularize/landPageUsers/LPjmy.vue"),
              meta: {
                title: "基木鱼用户 - 飞碟管理后台",
              },
            },
            {
              path: "/LPjl",
              name: "LPjl_",
              component: () =>
                import("./views/Popularize/landPageUsers/LPjl.vue"),
              meta: {
                title: "巨量点击用户 - 飞碟管理后台",
              },
            },
            {
              path: "/LP360",
              name: "LP360_",
              component: () =>
                import("./views/Popularize/landPageUsers/LP360.vue"),
              meta: {
                title: "360落地页用户 - 飞碟管理后台",
              },
            },
            {
              path: "/LPks",
              name: "LPks_",
              component: () =>
                import("./views/Popularize/landPageUsers/LPks.vue"),
              meta: {
                title: "快手落地页用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickOPPO",
              name: "clickOPPO_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickOPPO.vue"),
              meta: {
                title: "OPPO点击监测用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickVIVO",
              name: "clickVIVO_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickVIVO.vue"),
              meta: {
                title: "VIVO点击监测用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickHUAWEI",
              name: "clickHUAWEI_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickHUAWEI.vue"),
              meta: {
                title: "华为点击监测用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickWeibo",
              name: "clickWeibo_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickWeibo.vue"),
              meta: {
                title: "微博点击监测用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickBD",
              name: "clickBD_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickBD.vue"),
              meta: {
                title: "百度点击用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickTxADQ",
              name: "clickTxADQ_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickTxADQ.vue"),
              meta: {
                title: "腾讯ADQ点击用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickXT",
              name: "clickXT_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickXT.vue"),
              meta: {
                title: "星图点击用户 - 飞碟管理后台",
              },
            },
            {
              path: "/clickBilibili",
              name: "clickXT_",
              component: () =>
                import("./views/Popularize/clickMonitors/clickBilibili.vue"),
              meta: {
                title: "B站点击用户 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/JLindex",
          name: "JLindex_",
          component: () => import("./views/Market/JLindex.vue"),
          meta: {
            title: "巨量引擎 - 飞碟管理后台",
          },
          redirect: "/JLzh",
          children: [
            {
              path: "/JLzh",
              name: "JLzh_",
              component: () => import("./views/Market/JLpages/JLzh.vue"),
              meta: {
                title: "巨量引擎账户 - 飞碟管理后台",
              },
            },
            {
              path: "/JLggz",
              name: "JLggz_",
              component: () => import("./views/Market/JLpages/JLggz.vue"),
              meta: {
                title: "巨量引擎广告组 - 飞碟管理后台",
              },
            },
            {
              path: "/JLjh",
              name: "JLjh_",
              component: () => import("./views/Market/JLpages/JLjh.vue"),
              meta: {
                title: "巨量引擎计划 - 飞碟管理后台",
              },
            },
            {
              path: "/JLcy",
              name: "JLcy_",
              component: () => import("./views/Market/JLpages/JLcy.vue"),
              meta: {
                title: "巨量引擎创意 - 飞碟管理后台",
              },
            },
            {
              path: "/JLproject",
              name: "JLproject_",
              component: () => import("./views/Market/JLpages/JLproject.vue"),
              meta: {
                title: "巨量引擎2.0项目 - 飞碟管理后台",
              },
            },
            {
              path: "/JLpromotion",
              name: "JLpromotion_",
              component: () => import("./views/Market/JLpages/JLpromotion.vue"),
              meta: {
                title: "巨量引擎2.0广告 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/BDindex",
          name: "BDindex_",
          component: () => import("./views/Market/BDindex.vue"),
          meta: {
            title: "百度 - 飞碟管理后台",
          },
          redirect: "/BDzh",
          children: [
            {
              path: "/BDzh",
              name: "BDzh_",
              component: () => import("./views/Market/BDpages/BDzh.vue"),
              meta: {
                title: "百度账户 - 飞碟管理后台",
              },
            },
            {
              path: "/BDjh",
              name: "BDjh_",
              component: () => import("./views/Market/BDpages/BDjh.vue"),
              meta: {
                title: "百度计划 - 飞碟管理后台",
              },
            },
            {
              path: "/BDdy",
              name: "BDdy_",
              component: () => import("./views/Market/BDpages/BDdy.vue"),
              meta: {
                title: "百度单元 - 飞碟管理后台",
              },
            },
            {
              path: "/BDcy",
              name: "BDcy_",
              component: () => import("./views/Market/BDpages/BDcy.vue"),
              meta: {
                title: "百度创意 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/KSindex",
          name: "KSindex_",
          component: () => import("./views/Market/KSindex.vue"),
          meta: {
            title: "快手看板 - 飞碟管理后台",
          },
          redirect: "/KSzh",
          children: [
            {
              path: "/KSzh",
              name: "KSzh_",
              component: () => import("./views/Market/KSpages/KSzh.vue"),
              meta: {
                title: "快手看板账户 - 飞碟管理后台",
              },
            },
            {
              path: "/KSggz",
              name: "KSggz_",
              component: () => import("./views/Market/KSpages/KSggz.vue"),
              meta: {
                title: "快手看板账户 - 飞碟管理后台",
              },
            },
            {
              path: "/KSjh",
              name: "KSjh_",
              component: () => import("./views/Market/KSpages/KSjh.vue"),
              meta: {
                title: "快手看板账户 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/openGzh",
          name: "openGzh_",
          component: () => import("./views/Operate/openGzh"),
          meta: {
            title: "运营公众号管理 - 飞碟管理后台",
          },
        },
        {
          path: "/xcxScheme",
          name: "xcxScheme_",
          component: () => import("./views/Operate/xcxScheme"),
          meta: {
            title: "小程序跳转码 - 飞碟管理后台",
          },
        },
        {
          path: "/operateChannel",
          name: "operateChannel_",
          component: () => import("./views/Operate/operateChannel"),
          meta: {
            title: "运营书城渠道 - 飞碟管理后台",
          },
        },
        {
          path: "/xcxOperate",
          name: "xcxOperate_",
          component: () => import("./views/Operate/xcxOperate"),
          meta: {
            title: "小程序管理-运营版 - 飞碟管理后台",
          },
        },
        {
          path: "/xcxPut",
          name: "xcxPut_",
          component: () => import("./views/Operate/xcxPut"),
          meta: {
            title: "小程序管理-投手版 - 飞碟管理后台",
          },
        },
        {
          path: "/xcxSchemeUse",
          name: "xcxSchemeUse_",
          component: () => import("./views/Operate/xcxSchemeUse"),
          meta: {
            title: "小程序跳转码每日使用量 - 飞碟管理后台",
          },
        },
        {
          path: "/xcxSchemeData",
          name: "xcxSchemeData_",
          component: () => import("./views/Operate/xcxSchemeData"),
          meta: {
            title: "小程序跳转码数量统计 - 飞碟管理后台",
          },
        },
        {
          path: "/putLinkIndex",
          name: "putLinkIndex_",
          component: () => import("./views/Popularize/putLinkIndex.vue"),
          meta: {
            title: "快应用推广链接 - 飞碟管理后台",
          },
          redirect: "/putLinkWd",
          children: [
            {
              path: "/putLinkWd",
              name: "putLinkWd_",
              component: () =>
                import("./views/Popularize/putLinks/putLinkWd.vue"),
              meta: {
                title: "文鼎推广链接 - 飞碟管理后台",
              },
            },
            {
              path: "/putLinkCd",
              name: "putLinkCd_",
              component: () =>
                import("./views/Popularize/putLinks/putLinkCd.vue"),
              meta: {
                title: "常读推广链接 - 飞碟管理后台",
              },
            },
            {
              path: "/putLinkDz",
              name: "putLinkDz_",
              component: () =>
                import("./views/Popularize/putLinks/putLinkDz.vue"),
              meta: {
                title: "点众渠道 - 飞碟管理后台",
              },
            },
            {
              path: "/putLinkLd",
              name: "putLinkLd_",
              component: () =>
                import("./views/Popularize/putLinks/putLinkLd.vue"),
              meta: {
                title: "乐读推广链接 - 飞碟管理后台",
              },
            },
            {
              path: "/putlinkXcx",
              name: "putlinkXcx_",
              component: () =>
                import("./views/Popularize/videoXcx/putlinkXcx.vue"),
              meta: {
                title: "短剧小程序推广链接 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/pitcherDaily",
          name: "pitcherDaily_",
          component: () => import("./views/Statistics/pitcherDaily"),
          meta: {
            title: "投手天级统计：巨量 - 飞碟管理后台",
          },
        },
        {
          path: "/marketersData",
          name: "marketersData_",
          component: () => import("./views/Statistics/marketersData"),
          meta: {
            title: "设计天级统计：老版 - 飞碟管理后台",
          },
        },
        {
          path: "/marketersDataB",
          name: "marketersDataB_",
          component: () => import("./views/Statistics/marketersDataB"),
          meta: {
            // 设计师数据汇总-个人版
            title: "设计天级统计：新版 - 飞碟管理后台",
          },
        },
        {
          path: "/downTask",
          name: "downTask_",
          component: () => import("./views/Statistics/downTask"),
          meta: {
            title: "下载任务 - 飞碟管理后台",
          },
        },
        {
          path: "/jlPlan",
          name: "jlPlan_",
          component: () => import("./views/Statistics/jlPlan"),
          meta: {
            title: "巨量计划充值统计 - 飞碟管理后台",
          },
        },
        {
          path: "/bdPlan",
          name: "bdPlan_",
          component: () => import("./views/Statistics/bdPlan"),
          meta: {
            title: "百度单元充值统计 - 飞碟管理后台",
          },
        },
        {
          path: "/pitcherList",
          name: "pitcherList_",
          component: () => import("./views/Statistics/pitcherList"),
          meta: {
            title: "设计师别名管理 - 飞碟管理后台",
          },
        },
        {
          path: "/weiboPlan",
          name: "weiboPlan_",
          component: () => import("./views/Statistics/weiboPlan"),
          meta: {
            title: "微博计划 - 飞碟管理后台",
          },
        },
        {
          path: "/taskSync",
          name: "taskSync_",
          component: () => import("./views/Market/taskSync"),
          meta: {
            title: "同步任务列表 - 飞碟管理后台",
          },
        },
        {
          path: "/libraryList",
          name: "libraryList_",
          component: () => import("./views/PutMarket/libraryList"),
          meta: {
            title: "渠道书库 - 飞碟管理后台",
          },
        },
        {
          path: "/libraryDown",
          name: "libraryDown_",
          component: () => import("./views/PutMarket/libraryDown"),
          meta: {
            title: "渠道书库下载任务 - 飞碟管理后台",
          },
        },
        {
          path: "/pitcherLog",
          name: "pitcherLog_",
          component: () => import("./views/PutMarket/pitcherLog"),
          meta: {
            title: "投手操作日志 - 飞碟管理后台",
          },
        },
        {
          path: "/userInfor",
          name: "userInfor_",
          component: () => import("./views/Auth/userInfor"),
          meta: {
            title: "用户设置 - 飞碟管理后台",
          },
        },
        // 配置中心部分
        {
          path: "/dataDictionary",
          name: "dataDictionary_",
          component: () => import("./views/Configure/dataDictionary"),
          meta: {
            title: "数据字典 - 飞碟管理后台",
          },
        },
        {
          path: "/jumpQwQy",
          name: "jumpQwQy_",
          component: () => import("./views/Configure/jumpQwQy"),
          meta: {
            title: "跳转企业微信-企业列表 - 飞碟管理后台",
          },
        },
        {
          path: "/libraryDownParams",
          name: "libraryDownParams_",
          component: () => import("./views/Configure/libraryDownParams"),
          meta: {
            title: "渠道书库-下载参数管理 - 飞碟管理后台",
          },
        },
        {
          path: "/agentAdmin",
          name: "agentAdmin_",
          component: () => import("./views/Configure/agentAdmin"),
          meta: {
            title: "代理商管理 - 飞碟管理后台",
          },
        },
        {
          path: "/putBook",
          name: "putBook_",
          component: () => import("./views/PutData/putBook"),
          meta: {
            title: "推广作品管理 - 飞碟管理后台",
          },
        },
        {
          path: "/TxAdvHc",
          name: "TxAdvHc_",
          component: () => import("./views/Popularize/TxAdvHc.vue"),
          meta: {
            title: "腾讯广告回传设置 - 飞碟管理后台",
          },
        },
        {
          path: "/MPindex",
          name: "MPindex_",
          component: () => import("./views/Market/MPindex.vue"),
          meta: {
            title: "腾讯MP看板 - 飞碟管理后台",
          },
          redirect: "/MPzh",
          children: [
            {
              path: "/MPzh",
              name: "MPzh_",
              component: () => import("./views/Market/MPpages/MPzh.vue"),
              meta: {
                title: "腾讯MP账户 - 飞碟管理后台",
              },
            },
            {
              path: "/MPjh",
              name: "MPjh_",
              component: () => import("./views/Market/MPpages/MPjh.vue"),
              meta: {
                title: "腾讯MP计划 - 飞碟管理后台",
              },
            },
            {
              path: "/MPgg",
              name: "MPgg_",
              component: () => import("./views/Market/MPpages/MPgg.vue"),
              meta: {
                title: "腾讯MP广告 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/ADQindex",
          name: "ADQindex_",
          component: () => import("./views/Market/ADQindex.vue"),
          meta: {
            title: "腾讯ADQ看板 - 飞碟管理后台",
          },
          redirect: "/ADQzh",
          children: [
            {
              path: "/ADQzh",
              name: "ADQzh_",
              component: () => import("./views/Market/ADQpages/ADQzh.vue"),
              meta: {
                title: "腾讯ADQ账户 - 飞碟管理后台",
              },
            },
            {
              path: "/ADQjh",
              name: "ADQjh_",
              component: () => import("./views/Market/ADQpages/ADQjh.vue"),
              meta: {
                title: "腾讯ADQ计划 - 飞碟管理后台",
              },
            },
            {
              path: "/ADQgg",
              name: "ADQgg_",
              component: () => import("./views/Market/ADQpages/ADQgg.vue"),
              meta: {
                title: "腾讯ADQ广告 - 飞碟管理后台",
              },
            },
          ],
        },
        // 运营消息部分
        {
          path: "/materialAdd",
          name: "materialAdd_",
          component: () => import("./views/Operate/materialAdd"),
          meta: {
            title: "新建本地图文模板 - 飞碟管理后台",
          },
        },
        {
          path: "/gzhGroups",
          name: "gzhGroups_",
          component: () => import("./views/Operate/gzhGroups"),
          meta: {
            title: "公众号分组管理 - 飞碟管理后台",
          },
        },
        {
          path: "/publishRecord",
          name: "publishRecord_",
          component: () => import("./views/Operate/publishRecord"),
          meta: {
            title: "发表记录 - 飞碟管理后台",
          },
        },
        {
          path: "/operMessIndex",
          name: "operMessIndex_",
          component: () => import("./views/Operate/operMessIndex"),
          meta: {
            title: "运营消息 - 飞碟管理后台",
          },
          redirect: "/materialList",
          children: [
            {
              path: "/materialList",
              name: "materialList_",
              component: () =>
                import("./views/Operate/operMessage/materialList"),
              meta: {
                title: "本地图文模板管理 - 飞碟管理后台",
              },
            },
            {
              path: "/syncWxRecord",
              name: "syncWxRecord_",
              component: () =>
                import("./views/Operate/operMessage/syncWxRecord"),
              meta: {
                title: "草稿箱新建记录 - 飞碟管理后台",
              },
            },
            {
              path: "/wxMaterialDrafts",
              name: "wxMaterialDrafts_",
              component: () =>
                import("./views/Operate/operMessage/wxMaterialDrafts"),
              meta: {
                title: "微信图文消息：草稿箱 - 飞碟管理后台",
              },
            },
            {
              path: "/massManage",
              name: "massManage_",
              component: () => import("./views/Operate/operMessage/massManage"),
              meta: {
                title: "定时群发记录 - 飞碟管理后台",
              },
            },
            {
              path: "/imgTextPush",
              name: "imgTextPush_",
              component: () =>
                import("./views/Operate/operMessage/imgTextPush"),
              meta: {
                title: "智能图文推送管理 - 飞碟管理后台",
              },
            },
            {
              path: "/followReply",
              name: "followReply_",
              component: () =>
                import("./views/Operate/operMessage/followReply"),
              meta: {
                title: "关注后回复 - 飞碟管理后台",
              },
            },
            {
              path: "/sendMonthlyStatistics",
              name: "sendMonthlyStatistics_",
              component: () =>
                import("./views/Operate/operMessage/sendMonthlyStatistics"),
              meta: {
                title: "群发数据统计 - 飞碟管理后台",
              },
            },
          ],
        },
        {
          path: "/imgTextMessage",
          name: "imgTextMessage_",
          component: () => import("./views/Operate/operMessage/imgTextMessage"),
          meta: {
            title: "智能图文消息管理 - 飞碟管理后台",
          },
        },
        {
          path: "/wxDraftsEdit",
          name: "wxDraftsEdit_",
          component: () => import("./views/Operate/wxDraftsEdit"),
          meta: {
            title: "草稿箱编辑 - 飞碟管理后台",
          },
        },
        {
          path: "/putGroup",
          name: "putGroup_",
          component: () => import("./views/PutMarket/putGroup"),
          meta: {
            title: "投放分组 - 飞碟管理后台",
          },
        },
        {
          path: "/pitcherStatistics",
          name: "pitcherStatistics_",
          component: () => import("./views/Statistics/pitcherStatistics"),
          meta: {
            title: "投手天级统计 - 飞碟管理后台",
          },
        },

        {
          path: "/UEditorDemo",
          name: "UEditorDemo_",
          component: () => import("./views/UEditorDemo.vue"),
          meta: {
            title: "百度富文本 - 飞碟管理后台",
          },
        },

        {
          path: "/gzhFans",
          name: "gzhFans_",
          component: () => import("./views/OperateGzh/gzhFans.vue"),
          meta: {
            title: "粉丝列表 - 飞碟管理后台",
          },
        },
        {
          path: "/gzhTag",
          name: "gzhTag_",
          component: () => import("./views/OperateGzh/gzhTag.vue"),
          meta: {
            title: "标签管理 - 飞碟管理后台",
          },
        },
        {
          path: "/giftCurrency",
          name: "giftCurrency_",
          component: () => import("./views/PutMarket/giftCurrency.vue"),
          meta: {
            title: "赠送书币 - 飞碟管理后台",
          },
        },
        {
          path: "/giftCurrencyLog",
          name: "giftCurrencyLog_",
          component: () => import("./views/PutMarket/giftCurrencyLog.vue"),
          meta: {
            title: "赠送书币记录 - 飞碟管理后台",
          },
        },
        {
          path: "/fansMessage",
          name: "fansMessage_",
          component: () => import("./views/OperateGzh/fansMessage.vue"),
          meta: {
            title: "粉丝消息 - 飞碟管理后台",
          },
        },
        {
          path: "/menuManagement",
          name: "menuManagement_",
          component: () => import("./views/OperateGzh/menuManagement.vue"),
          meta: {
            title: "菜单管理 - 飞碟管理后台",
          },
        },
        {
          path: "/videoXcxList",
          name: "videoXcxList_",
          component: () =>
            import("./views/Popularize/videoXcx/videoXcxList.vue"),
          meta: {
            title: "短剧小程序列表 - 飞碟管理后台",
          },
        },
        {
          path: "/gzhConfigTemplate",
          name: "gzhConfigTemplate_",
          component: () => import("./views/OperateGzh/gzhConfigTemplate.vue"),
          meta: {
            title: "公众号配置模板 - 飞碟管理后台",
          },
        },
        {
          path: "/gzhConfigList",
          name: "gzhConfigList_",
          component: () => import("./views/OperateGzh/gzhConfigList.vue"),
          meta: {
            title: "公众号配置模板库 - 飞碟管理后台",
          },
        },
        {
          path: "/linkURL",
          name: "linkURL_",
          component: () => import("./views/Popularize/linkURL.vue"),
          meta: {
            title: "联调工具 - 飞碟管理后台",
          },
        },
        {
          path: "/bookCategory",
          name: "bookCategory_",
          component: () => import("./views/PutData/bookCategory.vue"),
          meta: {
            title: "作品分类列表 - 飞碟管理后台",
          },
        },
        {
          path: "/xcxList",
          name: "xcxList_",
          component: () => import("./views/Popularize/xcxList.vue"),
          meta: {
            title: "小程序列表 - 飞碟管理后台",
          },
        },

        {
          path: "/WBindex",
          name: "WBindex_",
          component: () => import("./views/Market/WBindex.vue"),
          meta: {
            title: "腾讯MP看板 - 飞碟管理后台",
          },
          redirect: "/MPzh",
          children: [
            {
              path: "/WBzh",
              name: "WBzh_",
              component: () => import("./views/Market/WBpages/WBzh.vue"),
              meta: {
                title: "微博账户 - 飞碟管理后台",
              },
            },
            {
              path: "/WBgg",
              name: "WBgg_",
              component: () => import("./views/Market/WBpages/WBgg.vue"),
              meta: {
                title: "微博广告系列 - 飞碟管理后台",
              },
            },
            {
              path: "/WBjh",
              name: "WBjh_",
              component: () => import("./views/Market/WBpages/WBjh.vue"),
              meta: {
                title: "微博广告计划 - 飞碟管理后台",
              },
            },
          ],
        },

        {
          path: "/jlCreateProject",
          name: "jlCreateProject_",
          component: () => import("./views/Market/jlCreateProject.vue"),
          meta: {
            title: "巨量广告-新建项目 - 飞碟管理后台",
          },
        },
      ],
    },
  ],
});

// 前置路由守卫
rout.beforeEach((to, form, next) => {
  // console.log('to',to)
  // console.log('form',form)

  if (to.name !== "login") {
    // 非登录页面
    if (localStorage.getItem("access_token")) {
      // 有登录信息
      document.title = to.meta.title;
      next();
    } else {
      // 没有登录信息
      next({ path: "/" });
    }
  } else {
    // 登录页面
    // console.log('登录页面to',to)
    // console.log('登录页面form',form)
    if (form.name) {
      // 如果刷新当前页面的话，就不存，不然会清掉从那个页面过来的信息
      // 存跳过来的路径。用于登录信息过期后跳到登录页重新登录，前往之前跳出来的页面
      sessionStorage.setItem("route_login_form", form.name);
    }

    next();
  }
});

export default rout;
